import React from 'react';

import {
  Button,
  Column,
  Copy,
  Flex,
  Heading,
  Image,
  Row,
  Square,
  Stack,
} from '@grubhubprod/gh-cookbook-react';

interface IEmptyStateProps {
  imageUrl: string;
  heading: string;
  subheading?: string;
  buttonName?: string;
  onButtonClick?: () => void;
  showButton?: boolean;
}

export function EnterpriseEmptyState({
  imageUrl,
  heading,
  onButtonClick,
  buttonName,
  subheading,
  showButton = true,
}: IEmptyStateProps): JSX.Element {
  return (
    <Square inset="lg" borderRadius="4px" dimension="1">
      <Row gutter={24}>
        <Column phone={9} gutter={24}>
          <Flex alignItems="center" height="100%">
            <Stack x="md">
              <Image
                width="60"
                height="40"
                src={imageUrl}
                role="presentation"
                alt=""
              />
            </Stack>

            <Copy variant="body" color="secondaryText">
              <Heading variant="h4">{heading}</Heading>
              {subheading && (
                <Copy variant="body" color="secondaryText">
                  {subheading}
                </Copy>
              )}
            </Copy>
          </Flex>
        </Column>
        {showButton && (
          <Column gutter={24} phone={3}>
            <Button
              variant="secondary"
              block
              buttonSize="medium"
              onClick={onButtonClick}
            >
              {buttonName}
            </Button>
          </Column>
        )}
      </Row>
    </Square>
  );
}
